export default __webpack_public_path__ + "static/dr-Stavrev-lutein-683e3a2ebba813a24ff972c6b262d568.jpg";